var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg38(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 568.85 222.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".h{fill:url(#e);}.i{fill:url(#d);}.j{fill:url(#g);}.k{fill:url(#f);}.l{fill:url(#c);}.m{fill:url(#b);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 138.41,
    y1: 78.21,
    x2: 97.66,
    y2: 8.94,
    gradientTransform: "translate(0 223.75) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff94a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#e03dc1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8247e5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 157.93,
    y1: 68.88,
    x2: 71.97,
    y2: 191.04,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 227.16,
    y1: 217.62,
    x2: 18.44,
    y2: 79.08,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 225.2,
    y1: 220.57,
    x2: 16.48,
    y2: 82.03,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 188.18,
    y1: 276.33,
    x2: -20.54,
    y2: 137.79,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 177.93,
    y1: 291.78,
    x2: -30.7,
    y2: 153.29,
    xlinkHref: "#b"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M104.95,222.49c12.77,0,23.73-7.65,28.6-18.61,1.18-2.67-.79-5.67-3.71-5.67h-49.78c-2.92,0-4.9,3-3.71,5.67,4.87,10.96,15.83,18.61,28.6,18.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M181.33,168.07c-8.1,0-14.66-6.56-14.66-14.66v-53.26c0-28.86-19.81-53.09-46.57-59.85-.98-7.61-7.47-13.5-15.35-13.5s-14.42,5.94-15.36,13.59c-24.02,6.23-42.34,26.56-45.64,51.63-.05,.37-.1,.73-.14,1.1-.06,.5-.11,.99-.15,1.49-.04,.5-.08,1-.11,1.5-.03,.42-.06,.83-.08,1.25-.04,.84-.06,1.69-.06,2.55,0,.08,0,.16,0,.24v53.25c0,8.06-6.5,14.6-14.55,14.66-3.84,.03-7.01,2.99-7.01,6.84v.06c0,3.81,3.09,6.9,6.9,6.9H181.31c3.81,0,6.9-3.09,6.9-6.9,.02-3.8-3.07-6.89-6.88-6.89Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M149.18,29.79c17.18,3.68,30.3,18.47,31.92,35.97,.18,1.94,1.87,3.39,3.85,3.2,.94-.09,1.79-.54,2.4-1.26,.6-.73,.89-1.65,.8-2.59-.95-10.22-5.07-19.67-11.92-27.35-6.8-7.61-15.64-12.76-25.57-14.89-.25-.05-.5-.08-.74-.08-1.63,0-3.11,1.14-3.46,2.8-.41,1.91,.81,3.79,2.72,4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M153.15,7.01c26.73,5.73,47.16,28.75,49.68,55.97,.18,1.94,1.87,3.38,3.85,3.2,.94-.09,1.79-.54,2.4-1.26,.6-.73,.89-1.65,.8-2.59-1.39-15.05-7.47-28.99-17.57-40.29C182.29,10.82,169.26,3.23,154.64,.09c-.25-.05-.5-.08-.74-.08-1.63,0-3.11,1.14-3.46,2.8-.42,1.91,.8,3.79,2.71,4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M60.71,29.79c1.91-.41,3.13-2.3,2.72-4.21-.36-1.66-1.83-2.8-3.46-2.8-.24,0-.49,.03-.74,.08-9.93,2.13-18.77,7.28-25.57,14.89-6.85,7.67-10.98,17.13-11.92,27.35-.09,.94,.2,1.86,.8,2.59s1.46,1.18,2.4,1.26c1.99,.18,3.67-1.26,3.85-3.2,1.62-17.48,14.75-32.27,31.92-35.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M56.74,7.01c1.91-.41,3.13-2.3,2.72-4.21-.36-1.66-1.83-2.8-3.46-2.8-.25,0-.49,.03-.74,.08-14.63,3.14-27.65,10.73-37.67,21.95C7.49,33.34,1.42,47.27,.02,62.32c-.09,.94,.2,1.86,.8,2.59s1.46,1.18,2.4,1.26c1.98,.18,3.67-1.26,3.85-3.2C9.59,35.76,30.02,12.75,56.74,7.01Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M538.49,52.31c-8.22-.05-15.93,3.07-21.75,8.8V16.28c0-.32-.26-.57-.58-.57h-17.34c-.32,0-.58,.26-.58,.57v121.01c0,.32,.26,.57,.58,.57h17.34c.32,0,.58-.26,.58-.57v-49.11c0-8.99,6.98-16.73,16.07-17.18,9.72-.47,17.77,7.2,17.77,16.69v49.6c0,.32,.26,.57,.58,.57h17.11c.32,0,.58-.26,.58-.57v-54.13c0-16.7-13.44-30.75-30.36-30.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.56,49.16h-17.26c-.32,0-.58,.26-.58,.57v53.72c0,9.21-7.82,16.65-17.24,16.19-8.82-.43-15.59-7.94-15.59-16.66V49.73c0-.32-.26-.57-.58-.57h-17.25c-.32,0-.58,.26-.58,.57v52.99c0,18.72,14.83,34.56,33.78,35.12,19.68,.58,35.89-15.07,35.89-34.39V49.73c-.01-.31-.27-.57-.59-.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.83,118.52c3.31,7.27,11.83,19.48,31.73,19.48,22.74,0,32.91-13.43,32.91-26.74,0-14.6-9.65-23.4-29.5-26.92-10.09-1.7-14.39-4.89-14.39-10.66,0-5.37,4.79-8.98,11.92-8.98,6.43,0,11.84,3.59,13.8,9.16,.04,.13,.14,.23,.26,.28s.24,.05,.36,0l14.27-6.37c.22-.1,.34-.36,.25-.59-4.37-11.27-15.27-18-29.13-18-19.63,0-29.9,12.42-29.9,24.69,0,14.5,9.46,23.24,28.93,26.74,10.36,2.09,14.78,5.39,14.78,11.04,0,6.09-5.37,9.73-14.37,9.73-6.86,0-13.15-3.93-16.03-10-.08-.17-.24-.27-.42-.27-.06,0-.13,.01-.19,.04l-15.05,6.79c-.23,.09-.33,.35-.23,.58Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M290.67,15.85h-43.21c-.63,0-1.15,.52-1.14,1.15v120.01c0,.63,.51,1.14,1.14,1.14h16.05c.63,0,1.14-.51,1.14-1.14l.1-47.14c0-.63,.51-1.15,1.14-1.15h24.77c20.06,0,35.78-16.01,35.78-36.45,.01-20.5-15.7-36.42-35.77-36.42Zm.33,54.67l-11.16,.02c-4.7,.01-8.84,3.09-10.19,7.59l-.54,1.79c-.12,.39-.47,.65-.88,.65h-2.65c-.51,0-.92-.41-.92-.92V35.12c0-.63,.51-1.14,1.14-1.14h23.89c9.43,0,17.46,6.94,18.5,16.31,1.23,10.97-6.59,19.89-17.19,20.23Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M250.08,194.77v-28.04h9.89c5.21,0,9.45,4.01,9.45,9.01s-4.05,9.29-9.45,9.29h-5.69v9.73h-4.21Zm4.21-13.62h5.01c3.28,0,5.69-2.32,5.69-5.41s-2.4-5.21-5.69-5.21h-5.01v10.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.72,194.77h-5.65l-10.61-10.73v10.73h-4.21v-28.04h9.77c5.65,0,9.33,3.97,9.33,8.53s-3.48,8.69-9.33,8.69h-.48l11.18,10.81Zm-16.26-24.19v9.53h5.09c3.4,0,5.41-2.04,5.41-4.85s-2-4.69-5.41-4.69h-5.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.22,180.75c0-8.09,6.37-14.42,14.58-14.42s14.58,6.33,14.58,14.42-6.41,14.42-14.58,14.42-14.58-6.33-14.58-14.42Zm24.71,0c0-5.77-4.29-10.33-10.13-10.33s-10.09,4.57-10.09,10.33,4.25,10.33,10.09,10.33,10.13-4.57,10.13-10.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.89,194.77v-24.11h-8.89v-3.93h22.07v3.93h-8.85v24.11h-4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.69,180.75c0-8.09,6.37-14.42,14.58-14.42s14.58,6.33,14.58,14.42-6.41,14.42-14.58,14.42-14.58-6.33-14.58-14.42Zm24.71,0c0-5.77-4.29-10.33-10.13-10.33s-10.09,4.57-10.09,10.33,4.25,10.33,10.09,10.33,10.13-4.57,10.13-10.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.47,180.75c0-8.09,6.37-14.42,14.5-14.42,5.41,0,9.69,2.56,12.18,6.49l-3.6,2.2c-1.68-2.76-4.77-4.61-8.57-4.61-5.69,0-10.05,4.53-10.05,10.33s4.37,10.33,10.05,10.33c3.81,0,6.89-1.88,8.57-4.61l3.6,2.16c-2.44,3.96-6.89,6.53-12.18,6.53-8.13,0-14.5-6.33-14.5-14.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.81,180.75c0-8.09,6.37-14.42,14.58-14.42s14.58,6.33,14.58,14.42-6.41,14.42-14.58,14.42-14.58-6.33-14.58-14.42Zm24.71,0c0-5.77-4.29-10.33-10.13-10.33s-10.09,4.57-10.09,10.33,4.25,10.33,10.09,10.33,10.13-4.57,10.13-10.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.56,194.77v-28.04h4.13v24.11h12.54v3.93h-16.66Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg38);
export default __webpack_public_path__ + "static/media/38.5a5725f45769914622d355c8115f82a9.svg";
export { ForwardRef as ReactComponent };